import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import ContextProvider from './store/context-provider';
import { initCloudWatchRum } from './aws-app-monitor/rum';
import { loadBootstrapStyles } from './loadBootstrapStyles';

initCloudWatchRum();
void loadBootstrapStyles().catch((err) => {
  console.warn("Failed to load Bootstrap CSS", err);
});

// Based on: https://stackoverflow.com/questions/75774800/how-to-stop-resizeobserver-loop-limit-exceeded-error-from-appearing-in-react-a
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    if (e.message && (
      e.message === 'ResizeObserver loop limit exceeded' ||
      e.message === 'ResizeObserver loop completed with undelivered notifications' ||
      e.message.startsWith('ResizeObserver loop')
    )) {
      const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
      const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
      
      if (resizeObserverErr) {
        resizeObserverErr.style.display = 'none';
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.style.display = 'none';
      }
      
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}

const container = document.getElementById('root');
document.title = "JigsawML"

const root = createRoot(container);

root.render(
	<React.StrictMode>
		{/* <img src={NewLogo} align="left" style={{ width: 125, height: 101, opacity: 1.0 }}></img> */}
		<Router>
			<ContextProvider>
				<App />
			</ContextProvider>
		</Router>

	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
